export interface ConfirmSignUpParams {
  email: string;
  lastName: string;
  firstName: string;
  cognitoId: string;
}

export class AuthState {
  isAuthenticated: boolean;
  shouldRedirectToConfirmSignUp?: boolean;
  confirmSignUpParams?: ConfirmSignUpParams;
  shouldLogout?: boolean;
}
